// components/Features.js
import React from 'react';
import AboutPreview from './AboutPreview';

const features = [
  {
    icon: 'ti-shield-check',
    title: '100% Genuine Products',
    description: 'Sourced exclusively from certified manufacturers with full authenticity guarantees.',
    badge: 'Certified',
    badgeIcon: 'ti-circle-check',
    accent: '#1D9E75',
    iconBg: '#E1F5EE',
    iconColor: '#0F6E56',
    badgeBg: '#E1F5EE',
    badgeColor: '#085041',
  },
  {
    icon: 'ti-truck-delivery',
    title: 'Fast Delivery',
    description: 'Timely dispatch and delivery across Gondia and all nearby areas — on schedule.',
    badge: 'Express',
    badgeIcon: 'ti-bolt',
    accent: '#185FA5',
    iconBg: '#E6F1FB',
    iconColor: '#185FA5',
    badgeBg: '#E6F1FB',
    badgeColor: '#0C447C',
  },
  {
    icon: 'ti-clock-hour-4',
    title: 'Business Hours',
    description: 'Mon–Sat: 9 AM – 5 PM. Sundays closed. Reliable service when you need it.',
    badge: 'Mon–Sat',
    badgeIcon: 'ti-calendar',
    accent: '#BA7517',
    iconBg: '#FAEEDA',
    iconColor: '#854F0B',
    badgeBg: '#FAEEDA',
    badgeColor: '#633806',
  },
  {
    icon: 'ti-microscope',
    title: 'Quality Assurance',
    description: 'Stringent multi-stage quality control at every step of our distribution process.',
    badge: 'ISO-grade',
    badgeIcon: 'ti-star',
    accent: '#1D9E75',
    iconBg: '#EAF3DE',
    iconColor: '#3B6D11',
    badgeBg: '#EAF3DE',
    badgeColor: '#27500A',
  },
  {
    icon: 'ti-award',
    title: 'Industry Experts',
    description: 'Years of deep expertise in pharmaceutical distribution and regulatory compliance.',
    badge: 'Expert team',
    badgeIcon: 'ti-ribbon',
    accent: '#D4537E',
    iconBg: '#FBEAF0',
    iconColor: '#993556',
    badgeBg: '#FBEAF0',
    badgeColor: '#72243E',
  },
  {
    icon: 'ti-headset',
    title: '24/7 Support',
    description: 'Dedicated customer care team available around the clock for all inquiries.',
    badge: 'Always on',
    badgeIcon: 'ti-phone-call',
    accent: '#7F77DD',
    iconBg: '#EEEDFE',
    iconColor: '#534AB7',
    badgeBg: '#EEEDFE',
    badgeColor: '#3C3489',
  },
];

const Features = () => {
  return (
    <section style={{
      fontFamily: "'DM Sans', sans-serif",
      padding: '1rem 1.5rem',
      background: 'linear-gradient(160deg, #E1F5EE 0%, #f8fdfa 40%, #E6F1FB 100%)',
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center'}}>
        
        <h2 style={{
          fontFamily: "'Outfit', sans-serif", fontSize: '2.4rem',
          fontWeight: 700, color: '#085041', lineHeight: 1.15, marginBottom: '.75rem',
        }}>
          Why <span style={{ color: '#1D9E75' }}>Choose Us?</span>
        </h2>
        <div style={{
          width: 56, height: 3,
          background: 'linear-gradient(90deg, #1D9E75, #185FA5)',
          borderRadius: 2, margin: '.75rem auto',
        }} />

 <AboutPreview />

      </div>

      {/* Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 20,
      }}>
        {features.map((f, i) => (
          <FeatureCard key={i} {...f} />
        ))}
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, title, description, badge, badgeIcon, accent, iconBg, iconColor, badgeBg, badgeColor }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff',
        border: `0.5px solid ${hovered ? 'rgba(29,158,117,.35)' : 'rgba(29,158,117,.18)'}`,
        borderRadius: 16,
        padding: '1.5rem 1.25rem',
        display: 'flex', flexDirection: 'column', gap: 12,
        position: 'relative', overflow: 'hidden',
        transform: hovered ? 'translateY(-4px)' : 'none',
        boxShadow: hovered ? '0 16px 40px rgba(15,110,86,.1)' : 'none',
        transition: 'transform .2s, box-shadow .2s, border-color .2s',
        cursor: 'default',
      }}
    >
      {/* Top accent bar */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: 3,
        background: accent, borderRadius: '16px 16px 0 0',
        opacity: hovered ? 1 : 0, transition: 'opacity .2s',
      }} />

      {/* Icon */}
      <div style={{
        width: 52, height: 52, borderRadius: 14,
        background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <i className={`ti ${icon}`} style={{ fontSize: 26, color: iconColor }} aria-hidden="true" />
      </div>

      {/* Text */}
      <div>
        <p style={{ fontFamily: "'Outfit',sans-serif", fontSize: 15, fontWeight: 600, color: '#085041', lineHeight: 1.3, marginBottom: 6 }}>
          {title}
        </p>
        <p style={{ fontSize: 13, color: '#0F6E56', lineHeight: 1.55, opacity: 0.75 }}>
          {description}
        </p>
      </div>

      {/* Badge */}
      <div style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: badgeBg, color: badgeColor,
        fontSize: 11, fontWeight: 500, padding: '3px 10px',
        borderRadius: 100, marginTop: 'auto', width: 'fit-content',
      }}>
        <i className={`ti ${badgeIcon}`} style={{ fontSize: 12 }} aria-hidden="true" />
        {badge}
      </div>
    </div>
  );
};

export default Features;